<ion-header class="ion-padding header header-modal" mode="md">
  <ion-toolbar class="ion-no-padding" mode="ios" color="white">
    <ion-buttons slot="end">
      <ion-button (click)="onCancel()">
        <ion-icon name="close" mode="md"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content min="0" max="2400" color="white" class="ion-padding profile">
  <div class="ion-padding profile__picture">
    <img [src]="employee?.avatar?.document?.fileName | ppImage">
  </div>

  <div class="ion-padding profile__info">
    <h1>{{ employee.name }}</h1>
    <h2>{{ employee.shortDescription | ppTranslate:employee.shortDescriptionTranslations:translateService.currentLang }}</h2>
    <p *ngIf="employee.longDescription" class="formatted" innerHtml="{{ employee.longDescription | ppTranslate:employee.longDescriptionTranslations:translateService.currentLang }}"></p>
  </div>

  <a (click)="onCancel()" class="pp-link">{{ 'EMPLOYEE_MODAL.CLOSE' | translate }}</a>
</ion-content>
